import { render, staticRenderFns } from "./MatchChangeRequestButton.vue?vue&type=template&id=55640dc5&scoped=true&"
import script from "./MatchChangeRequestButton.vue?vue&type=script&lang=js&"
export * from "./MatchChangeRequestButton.vue?vue&type=script&lang=js&"
import style0 from "./MatchChangeRequestButton.vue?vue&type=style&index=0&id=55640dc5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55640dc5",
  null
  
)

export default component.exports